import { DestroyRef, Injectable } from '@angular/core';
import version from '../../../../../package.json';
import { API } from '../../api/api';
import { ModalService } from '../modal/modal.service';
import { ChangelogModalComponent } from './changelog-modal/changelog-modal.component';
import { map, switchMap } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ChangelogService {
  public frontendVersion: string;
  public backendVersion: string;
  public frontendChangelog: string[];
  public backendChangelog: string[];
  public backendName: string;
  public revision: string = '${gitHash}';
  public branch: string = '${gitBranch}';

  constructor(
    private api: API,
    private modalService: ModalService,
    private destroyRef: DestroyRef
  ) {
    this.retrieveBackendInformation();

    this.frontendVersion = version.version; // CHANGE ME IN package.json !!!!!!!!
    this.frontendChangelog = [
      //  for 0.94.0 from 0.93.0
      'Bug fixes',
      'Translation updates',
      'Various minor layout fixes',
      'Display of Chained Culls',
      'Added Campaign, Commercial and Requirement copy function',
      'Added Campaign, Commercial and Requirement jump to booking function',
      'Added Marker display and filtering in Channels',
      'Added in-use indicator to filter-list and corresponding filtering',
      'Moved filtering to Queryparams instead of localstorage',
      'Added new booking feature',
      'Added new device details pages (network booking, setlist, content-share, ...)',
      'Fixed template group selection in Medium-edit',
      'Fixed upload queue cancelation on multiple upload when selected no to double media',
      'Fixed requirement export loading bug',
      'Fixed booking state calculation',
      'Moved export to standard reporting, added custom naming ( devices, locations, companies)',
    ];

    /*
    this.frontendChangelog = [

      //  for 0.93.0 from 0.89.0
      'Bug fixes',
      'Translation updates',
      'Performance increased',
      'Advertiser Share of Voice extension and improvements',
      'Fixed Search',
      'Device Options fixes',
      'Fixed Attribute Allowed Values',
      'Fixed templateDataset entry display',
      'Fixed Filter preview display',
      'Fixed Commercial sorting',
      'Removed DMP feature',
      'Fixed role edit display',
      'Extended Template Dataset Entry Table',
      'Permission fixes',
      'Fixed Content Share Creation/Edit',
      'Added Timerange filter for content share',
      'Added Description and identifier field to commercial/requirement',
      'Added circular dependency check and warning on schedules ',
      'Added Multiple drag and drop to folder on medium explorer',
      'Fixed Templateentry input',
      'Fixed Filtercategory selection',
      'Added Resolution to Channellist',
      'Updated Errormodal',
      'Extended filter functionality on network bookings list',
      'Added new sorting options to device list',
      'Fixed no Permission display',
      'Fixed and extended Inventory view',
      'Fixed multiple device creation',
      'Fixed template entry rejection',
      'Fixed category creation',
      'Added weekly cycle filter for locations',
      'Added setlist to device details',
      'Added content share to device details',
      'Added playbackschedule to device details',
      'Renaming of Bookings page to Networkallocation',
      'Added contentshare and playbackschedule to network allocation',
      'Added Dashboard welcome tile',
      'Added missing configuration tile',
      'Added Usage count to filter-details',
      'Added Devices Heatmap to Dashbaord, device details and player reporting',
      'Added show in folder view to mediumexplorer and medium groups',

    ];
    /*
    this.frontendChangelog = [
      //  for 0.89.0 from 0.87.0
      'Bug fixes',
      'Translation updates',
      'Performance increased',
      'Assigned MediumGroup introduced',
      'Filter fixes',
      'Login fixes',
      'Ordering update',
      'Scroll issues fixed',
      'advertiser Share of Voice',
      'Permission updates',
      'Attribute extended functionality',
      'Contentshare distribution base',
    ];


    /*
    this.frontendChangelog = [

      //  for 0.87.0 from 0.85.0
      'Bug fixes',
      'Translation updates',
      'Pagination increased',
      'Assigned MediumGroup introduced',
      'Assigned TemplateDataSet introduced',
      'Timerange filtering on campaigns and commercials',
      'Copying of commercials & requirements',
      'Planning Calendar editor fixes and improvements',
      'Added filter on verifications',
      'Content filtering at Commercials and network booking list',
      'Medium Attributes moved to Motivegroups',
      'Permission updates',
      'Dropdownselect styling update',
      'Calibration image option in device dialog',
      'Content Share',
      'Improvements for Pages with Hierarchy',
      'Table cell value display more human readable',
      'Chained Content and Client Filter',
      'Filter name checking',
      'Tag service improvements',
      'Improved Data requests',
      'multiple device creation',
      'Upgrade auf Angular 18',
      'Campaign, Commercial ordering and time filtering',
    ];

    /*
     this.frontendChangelog = [
      //  for 0.85.0 from 0.84.1
      'Bug fixes',
      'Translation updates',
      'scrollbar and scroll behaviour adjustments',
      'Password reset convenience update',
      'Login styling',
      'Targeting improvements',
      'Planning editor fixes and improvements',
      'Wizard updates',
      'Device Options improvements',
      'Permission fixes in device details',
      'Inventory addition of Screenscope',
      'Improved playlist presentation',
      'Content Share'
    ];
     */

    /*
    this.frontendChangelog = [
      //  for 0.84.1 from 0.81.0
      'Bug fixes',
      'Translation updates',
      'scroll behaviour',
      'Improved Security',
      'IDP Login options',
      'New Login styling',
      'Targeting improvements',
      'Targeting chart',
      'Planning editor fixes and improvements',
      'Location geo position fix',
      'Geo Cull advanced mode',
      'Improved playlist presentation',
      'Cull visibility improvements',
      'Template dataset value display in device Details',
      'Multi medium selection functionality improvements',
      'Medium Transformation',
      'Device Options refactoring and additional functionality',
      'Improved Subscriptions',
      'Chart adjustment',
      'Role edit improvements',
      'Thumbnail fetching',
      'Medium Explorer Multiselect',
      'Playlist & Setlist adjustments',
      'Permission fixes',
      'Playouts in Campaign, Commercial',
      'Aggregated Playlists',
      'Verfied-At&By + Denied-At&By in Verification',
      'Pagination count increase',
      'Client cull adjustments',
    ];

    /*
    this.frontendChangelog = [
      //  for 0.83.0
      'Bug fixes',
      'Translation updates',
      'scroll behaviour',
      'Device Options additional functionality',
      'Improved Security',
      'IDP Login options',
      'New Login styling',
      'Targeting chart improvements',
      'Planning editor fixes and improvements',
      'Location geo position fix',
      'Geo Cull advanced mode',
      'Improved playlist presentation',
      'Cull visibility improvements',
      'Template dataset value display in device Details',
      'Multi medium selection functionality improvements',
      'Medium Transformation',
    ];

    /*
    this.frontendChangelog = [
      //  for 0.81.1
      'Bug fixes',
      'Translation updates',
      'scroll behaviour',
      'Device Options refactoring and additional functionality',
      'Improved Subscriptions',
      'Targeting',
      'Chart adjustment',
      'New targeting Chart',
    ];

    /*this.frontendChangelog = [
      //  for 0.80.0
      'Bug fixes',
      'Translation updates',
      'scroll behaviour',
      'Role edit improvements',
      'Thumbnail fetching',
      'Medium Explorer Multiselect',
      'Playlist & Setlist adjustments',
      'Device Attributes in Modal',
      'Improved upload functionality',
      'Targeting',
    ];

    /*
                        this.frontendChangelog = [ //  for 0.78.4
                          'Bug fixes',
                          'Translation updates',
                          'Admin Area update',
                          'Password reset improvements',
                          'Permission adjustments',
                          'View Setting refactoring',
                          'Templating updates',
                          'Network share improvements',
                          'Search select modal functionality increased',
                          'Weekly Cycles',
                          'Cull Convenience updates',
                          'Cull Categories',
                        ];

                        /*
                        this.frontendChangelog = [ //  for 0.77.4
                          'Device extension',
                          'Asset updates',
                          'Translation updates',
                          'View Setting refactoring',
                          'Storage service updates',
                          'Setlist and Playlist update',
                          'Client Cull with Atoms',
                          'Content Cull with Atoms',
                          'Content Cull in Schedules',
                          'Bug fixes',
                          'Password restore update',
                          'Schedules updates',
                          'Schedule Fallback',
                          'Network Share bookable options',
                          'Password reset improvements',
                          'Filter Hide functionality',
                          'SSP extension',
                          'Geo Cull',
                        ];

                        /*
                        this.frontendChangelog = [ //  for 0.75.5
                          'Device extension',
                          'Asset updates',
                          'Translation updates',
                          'View Setting refactoring',
                          'Storage service updates',
                          'Setlist and Playlist update',
                          'Client Cull with Atoms',
                          'Bug fixes'
                        ];

                        /*
                        this.frontendChangelog = [ //  for 0.74.0
                          'Angular 15',
                          'Reservations',
                          'Permission update',
                          'Icon updates',
                          'Bug fixes'
                        ];
                        this.frontendChangelog = [ //  for 0.73.0
                          'Bug fixes',
                          'Translation updates',
                          'Assets',
                          'Permission update',
                          'Icon updates',
                          'Client settings',
                          'Client Management',
                          'ISO Country Codes',
                          'Admin Panel Extension'
                        ];

                        this.frontendChangelog = [ //  for 0.71.0
                          'Bug fixes',
                          'Translation updates',
                          'Asset alpha test',
                          'Permission update',
                          'Icon updates',
                          'Client settings',
                          'Client Management',
                          'ISO Country Codes',

                        ];

                        /*
                        this.frontendChangelog = [ //  for 0.68.0
                          'Bug fixes',
                          'Translation updates',
                          'Multiple medium verification',
                          'Global company select',
                          'Icon updates',
                          'Card display header addition',
                          'Folder structure in Medium Explorer',
                          'Folder structure in MediumGroups'
                        ];

                        /*this.frontendChangelog = [ //  for 0.65.1
                          'Bug fixes',
                          'Translation updates',
                          'Multiple medium verification',
                          'Export Reports convenience update',
                          'Global company select',
                          'List filtering updates',
                          'Icon updates',
                          'Card display header addition',
                          'Folder structure in Medium Explorer',
                          'Upload queue'
                        ];
                        /*
                        this.frontendChangelog = [ //  for 0.63.3
                          'Bug fixes',
                          'Translation updates',
                          'Multiple medium verification',
                          'Client change convenience update',
                          'Generated Reports',
                          'Campaign Export',
                          'Commercial Export',
                          'Requirements Export',
                          'Report Rendering',
                          'Error page/display adjustments',
                          'Share of Voice Publisher',
                          'Campaign targeting display',

                        ];
                          /*
                          this.frontendChangelog = [ //  for 0.63.2 and below
                              'Bug fixes',
                              'Translation updates',
                              'Generated Reports',
                              'Campaign Export',
                              'Commercial Export',
                              'Requirements Export',
                              'Report Rendering',
                              'Error page/display adjustments',
                              'Share of Voice Publisher',
                              'Campaign targeting display',

                          ];
                           */

    /* this.frontendChangelog = [ //  for 0.60.6 / hotfix of 0.60.5
                            'Bug fixes',
                            'Translation updates',
                            'Generated Reports',
                            'Device Export renewal',
                        ];

                         */

    /* this.frontendChangelog = [ //  for 0.60.4
                          'Bug fixes',
                          'Translation updates',
                          'Color Page',
                          'Color Presets',
                        ];

                         */

    /*;this.frontendChangelog = [ //  for 0.60.3
                          'Bug fixes',
                          'Translation updates',
                          'Priority changes for schedules and share',
                          'Planning updates',
                          'Device Details Adjustments',


                        ];
                        /*this.frontendChangelog = [ //  for 0.60.2
                          'Bug fixes',
                          'chart fixes',
                          'Inventory extension',

                        ];
                        /*
                        this.frontendChangelog = [ //  for 0.60.1
                          'Bug fixes',
                          'Performance update',
                          'Translation updates',
                          'DMP data addition',
                          'Visibility updates',
                          'Partial Plannings updates',

                        ];

                        /*this.frontendChangelog = [ // 0.58.0
                          'Various Bug fixes',
                          'Translation updates',
                          'Performance update',
                          'Convenience updates',
                          'Booking editor update',
                          'Partial plannings',
                          'Time plannings',
                          'Filter updates',
                          'Admin area adjustments',
                          'Campaign level update',
                        ];


                        /*this.frontendChangelog = [ // 0.56.7
                          'Various Bug fixes',
                          'Translation updates',
                          'Performance update',


                        ];
                        /*
                        this.frontendChangelog = [ // 0.56.4
                          'Various Bug fixes',
                          'Translation updates',
                          'Added new own Icons',
                          'Performance update',
                          'Admin area update',
                          'Device Updates',
                          'Errorcodes update',
                          'Client creation/edit updates'


                        ];
                        /*
                        this.frontendChangelog = [ // 0.56.3
                          'Various Bug fixes',
                          'Translation updates',
                          'Added new own Icons',
                          'Performance update',
                          'Navigation refactor',
                          'Routing changes',
                          'User settings update',
                          'Additional device options',
                          'Campaign ordering adjustments',
                          'Search improvements',
                          'Tracker screen assignments',
                          'Date- and Time-picker updates',

                        ];
                        /*
                        this.frontendChangelog = [ // 0.53.2 / 0.55.0
                          'Various Bug fixes',
                          'Dark Mode fixes',
                          'Translation updates',
                          'Added new own Icons',
                          'Filter updates',
                          'Table usability improvement',
                          'Player Hardware & Software',
                          'Screen Hardware',
                          'Chart update',
                          'Performance update',
                          'Responsive Design',
                          'Navigation adjustment',
                          'Attachments',
                          'UI changes',
                          'Password requirements',
                          'Login adjustment',
                          'Map fixes',
                          'Image updates',
                          'Campaign ordering',
                          'Admin area updates',
                          'User settings updates',
                          'Toast updates',
                          'Tag lookup position fixes',
                          'Primary company switch button',
                          'Default view setting on lists',
                          'Breadcrumb a tag fix',
                          'color picker in plannings'
                        ];

                        /*this.frontendChangelog = [ // 0.50.0
                          'Various Bug Fixes',
                          'Dark Mode Fixes',
                          'Translation Updates',
                          'Own Icons',
                          'Welcome Mail',
                          'Discussion Feature',
                          'Image Upload and cropping',
                          'Inventory View',
                          'Password Reset Update',
                          'Security Updates',
                          'Datetimepicker Update',
                          'Products and Product Categories',
                          'Errorhandler Updates',
                          'Content Editor',
                          'Template-Group, -Source and -Entry',
                          'Navigation and Routing Update',
                          'Filter updates',
                          'Permission Updates',
                          'Table Wrapper',
                          'Medium Explorer Updates',
                          'Targeting and Budget',
                          'Pricing for Slots',
                          'Deals',
                          'SSPs and SSP Contracts',
                          'Tracker and corresponding Statistics',
                          'Multiselect / Dropdownselect',
                          'Various Warnings',


                        ];
                        /*
                      this.frontendChangelog = [
                        "Tags added",
                        "Various Bug Fixes",
                        "Dark Mode",
                        "Network Share",
                        "Share of Voice Infocard",
                        "Shortclick in Elements"
                      ];
                      /* this.frontendChangelog = [
                        "Client/Company Scopes",
                        "Planning and Booking Editor fixes",
                        "Cull overhaul",
                        "Translations",
                        "Fix Christmas",
                        "User Profile",
                        "New Navbar",
                        "Company Details",
                        "Cull Details",
                        "New Charts",
                        "Reporting overhaul",
                        "Pool details",
                        "Campaigntypes",
                        "Switch Client Modal overhaul",
                        "Responsiveness",
                        "Update Cull API",
                        "List query params",
                        "New Pagination Component",
                        "Campaigns/Commercials boolean toggles",
                        "Security Trimming",
                        "Roles/Users overhaul",
                        "CVS info"
                      ];
                     this.frontendChangelog = [
                        "Planning and Booking Editor",
                        "Drag and Drop Fix",
                        "Various Bug Fixes",
                        "Slide Commercial Captions",
                        "Tab Font for Numbers"
                      ];

                          this.frontendChangelog = [
                            "Filter Autocomplete and Bugfixes",
                            "seatback UI Kit v0.0.20",
                            "New Booking Logic",
                            "Preview Call HOTFIX",
                            "Fixed Table Actions",
                            "Channel Airtime Quota",
                            "New Button Size and Toggle Component",
                            "Requirement Motive Preview",
                            "Set Motive Group Preview",
                            "Truncate Pipe in Motive Explorer",
                            "In Use Fix for Motives",
                            "Bugfixes"
                          ];

                              this.frontendChangelog = [
                                "seatback UI Kit v0.0.17",
                                "Schedules",
                                "Modal Template and Animation",
                                "Airtime Quota",
                                "Bugfixes"
                              ];


                                  this.frontendChangelog = [
                                    "seatback UI Kit v0.0.15",
                                    "Translation",
                                    "Campaign Edit Navigation Fix",
                                    "Channels",
                                    "Create Device bugfix",
                                    "Motiveexplorer fixes",
                                    "Mediumgroup fixes",
                                    "Mediumgroup company filter",
                                    "Attributes fixes",
                                    "Attributes regex + readonly/unique",
                                    "Permission fixes",
                                    "Navigation fixes",
                                    "Security trimming culls",
                                    "Security trimming navpoints",
                                    "Motive Explorer Company/Customer Settings",
                                    "Location creation Bugfix (no company fix)",
                                    "Campaign Preview fix",
                                    "Cull Company fixes",
                                    "Separate Company Lists",
                                    "Navbar fixes",
                                    "Some more Dashboard statistics added"
                                  ];


                                  this.frontendChangelog = [
                                    "Location Update Buxfixes",
                                    "Company Management Bugfixes",
                                    "Location Management",
                                    "Geocoding Bugfixes",
                                    "Area Management",
                                    "Area Categories Management",
                                    "Translations",
                                    "company list",
                                    "company management",
                                    "channel list",
                                    "location view updated",
                                    "cluster map reworked",
                                    "campaign edit adjustments",
                                    "medium explorer reworked",
                                    "\"n.def.\" reworked",
                                    "name and identifier in location",
                                    "return To navigation",
                                    "n.def. / \"empty\" filters device list",
                                    "bugfix list selected columns",
                                    "default columns updated (plus order)",
                                    "map ctrl to zoom",
                                    "refactoring",
                                    "Location Link device details page",
                                    "location inventory list",
                                    "exact match fix",
                                  ];
                                  */

    /*
                        this.frontendChangelog = [
                          "Location Update",
                          "Company Management",
                          "Location Management",
                          "Geocoding",
                          "Location Edit Map -> What is here?",
                          "Threeway Toggles reworked",
                          "Attribute Filters",
                          "DMP Data",
                          "bugfixes"
                        ];
                        */

    /*
                        this.frontendChangelog = [
                          "Login Screen Redirect Fixes",
                          "Planned Offline",
                          "DateTime, Date, Time Fixes",
                          "Companies List WIP",
                          "Schedules List WIP",
                          "Login Screen Enter to submit",
                          "Geocoding Prepwork",
                          "DateTime, Date, Time implementations",
                          "GeoJSON",
                          "Calendar Hover Fixes",
                          "New Search in Lists",
                          "Error Handler Erroridentifiers",
                          "Campagin/Booking redesign",
                          "Impersonation",
                          "Mediaexplorer Upload Bugfix",
                          "New Error Handler",
                          "New Login Screen",
                          "Cull Easymode",
                          "Time Cull Fixes",
                          "SMIL, Neon Playlist Download",
                          "Group management hotfix"
                        ];
                        */

    /*
                        this.frontendChangelog = [
                          "New permission system",
                          "Motive groups sorting, pagination, search",
                          "\"HD Ready\"' responsive WIP",
                          "Altered JWT Token acquisition",
                          "Commercial List Playback Order",
                          "Client/Company Structure Backend",
                          "Password restore",
                          "Styling",
                          "New Reporting Dashboard",
                          "Active/Stop Campaigns,Commercials,..",
                          "New theme for booking overview"
                        ];
                        */
    /*
                        this.frontendChangelog = [
                          "Commercial List Playback Order",
                          "Client/Company Structure Backend",
                          "Password restore",
                          "Styling"
                        ];
                        */
    /*
                        this.frontendChangelog = [
                          "New Reporting Dashboard",
                          "Active/Stop Campaigns,Commercials,..",
                          "New theme for booking overview"
                        ];
                        */
    /*
                    this.frontendChangelog = [
                      "New DateTime System",
                      "Theming",
                      "New dynamic player aggregation including corrected online status"
                    ];


                    this.frontendChangelog = [
                      "Dashboard -> Replaced dummy data with real data",
                      "Dashbaord -> Change order of values",
                      "Reporting -> Location and player reporting",
                      "Reporting -> remove bottom padding",
                      "Reporting -> Round values",
                      "Devices -> new layout",
                      "Ghost element added",
                      "Devices -> add column type icons with tooltips to select columns dropdown",
                      "Devices -> fix column type identification (prevent name collisions)",
                      "Devices -> fix column order",
                      "Devices -> fix column order settings loading",
                      "Devices -> added new device online states (Connected, Currently Offline, Offline, Unknown",
                      "Devices -> implemented new online states toggles reflecting the newly added device online states",
                      "Devices -> remove devlistscroll ps component viewchild (got removed from markup due to redesign)",
                      "Navbar -> add disable attribute",

                    ];
                    */

    /*
                       this.frontendChangelog = [
                        "Campaigns -> new wizard",
                        "Motive Explorer -> Drag and Drop",
                        "Motive Explorer -> Multiupload",
                        "new Dashboard"
                       ];


                       this.frontendChangelog = [
                           "Show versioning and changelogs",
                           "Network -> Bookings: redesign",
                           "Network -> Bookings: show Playlists",
                           "Network -> Devices -> Device details: integrate Playlist search (work in progress)"
                       ]
                       */
  }

  retrieveBackendInformation() {
    this.api
      .de_bpr_systems_web_api_rest_API_version()
      .pipe(
        map(backendVersion => {
          this.backendVersion = backendVersion as unknown as string;
        }),
        switchMap(() => this.api.de_bpr_systems_web_api_rest_API_changelog()),
        map(backendChangelog => {
          this.backendChangelog = backendChangelog as unknown as string[];
        }),
        switchMap(() => this.api.de_bpr_systems_web_api_rest_API_application()),
        takeUntilDestroyed(this.destroyRef),
        take(1)
      )
      .subscribe({
        next: backendName => {
          if (backendName) {
            this.backendName = backendName;
          }
        },
        error: error => {
          if (error?.status && (error?.status >= 400 || error?.status < 500)) {
            if (error.status === 400) {
              this.retrieveBackendInformation();
            }
          }
        },
      });
  }

  getFrontendVersion(): string {
    return this.frontendVersion;
  }

  getBackendVersion(): string {
    return this.backendVersion;
  }

  getFrontendChangelog(): string[] {
    return this.frontendChangelog;
  }

  getBackendChangelog(): string[] {
    return this.backendChangelog;
  }

  getFrontendName(): string {
    return 'Frontend';
  }

  getBackendName(): string {
    return this.backendName ? this.backendName : 'seatback CMS Core';
  }

  showFrontendChangelog() {
    this.modalService
      .showNavigationModal({
        entryComponent: {
          value: ChangelogModalComponent,
          data: {
            title: 'seatback adplacer Frontend',
            subTitle: 'Version ' + this.getFrontendVersion(),
            branch: this.branch,
            revision: this.revision,
            changeLog: this.getFrontendChangelog(),
          },
        },
        title: null,
        /*modalOptions: {windowClass: 'bigXL'}*/
      })
      .then(() => {})
      .catch(() => {});
  }

  showBackendChangelog() {
    this.modalService
      .showNavigationModal({
        entryComponent: {
          value: ChangelogModalComponent,
          data: {
            title: this.getBackendName() ? this.getBackendName() : 'seatback CMS Core',
            subTitle: 'Version ' + this.getBackendVersion(),
            changeLog: this.getBackendChangelog(),
          },
        },
        title: null,
        /*modalOptions: {windowClass: 'bigXL'}*/
      })
      .then(() => {})
      .catch(() => {});
  }
}
